<div class="flex align-items-center gap-2">
    <label for="darkModeSwitch">Dark Mode</label>
    <p-toggleswitch inputId="darkModeSwitch" [(ngModel)]="darkMode" (onChange)="changeDarkMode()" />
</div>